<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_NAME_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_NAME_CHANGE_INPUT_LASTNAME' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="lastName" name="lastName" 
                                [(ngModel)]="request.lastName"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.lastName.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                            
                                required maxlength="100"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_NAME_CHANGE_INPUT_FIRSTNAME' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="firstName" name="firstName" 
                                [(ngModel)]="request.firstName"                   
                                maxlength="100"/>
                        </section>
                        <section class="col-sm-12" style="margin-top: 15px;">
                            <p class="subtitle">{{ 'REQUEST_NAME_CHANGE_TITLE' | translate }}</p>
                            <p>{{ 'REQUEST_NAME_CHANGE_SUBTITLE1' | translate }}</p>
                            <p>{{ 'REQUEST_NAME_CHANGE_SUBTITLE2' | translate }}</p>
                            <p>{{ 'REQUEST_NAME_CHANGE_SUBTITLE3' | translate }}</p>
                            <ul>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE31' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE32' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE33' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE34' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE35' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE36' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE37' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE38' | translate }}</li>
                                <li>{{ 'REQUEST_NAME_CHANGE_SUBTITLE39' | translate }}<br>
                                    {{ 'REQUEST_NAME_CHANGE_SUBTITLE310' | translate }}</li>
                            </ul>
                        </section>
                        <section class="col-sm-12" style="margin-top: 15px;"></section>
                        <section class="col-sm-6 lb" *ngIf="governmentIdIsRequired"><label class="star">*</label>{{ 'REQUEST_NAME_CHANGE_INPUT_GOVERNMENT_ISSUED_ID' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;" *ngIf="governmentIdIsRequired">
                            <input type="file"
                                id="governmentIdFileInput" name="governmentIdFileInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                (change)="handleGovernmentIdFileInput($event.target.files)"/>
                            <button type="button" id="governmentIdFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!governmentIdFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="governmentIdFile"><small>{{ governmentIdFile?.name }}</small></div>
                            <div *ngIf="governmentIdFile && invalidGovernmentIdFile" [ngClass]="{ 'is-invalid-file': invalidGovernmentIdFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section>                         
                        <section class="col-sm-6 lb" *ngIf="articlesOfIncorporationIsRequired"><label class="star">*</label>{{ 'REQUEST_NAME_CHANGE_INPUT_ARTICLES_OF_INCORPORATION' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;" *ngIf="articlesOfIncorporationIsRequired">
                            <input type="file"
                                id="articlesOfIncorporationFileInput" name="articlesOfIncorporationFileInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif"
                                (change)="handleArticlesOfIncorporationFileInput($event.target.files)"/>
                            <button type="button" id="articlesOfIncorporationFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!articlesOfIncorporationFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="articlesOfIncorporationFile"><small>{{ articlesOfIncorporationFile?.name }}</small></div>
                            <div *ngIf="articlesOfIncorporationFile && invalidArticlesOfIncorporationFile" [ngClass]="{ 'is-invalid-file': invalidArticlesOfIncorporationFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section>   
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_NAME_CHANGE_INPUT_UPDATED_VEHICLE_REGISTRATION' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;">
                            <input type="file"
                                id="vehicleRegistrationFileInput" name="vehicleRegistrationFileInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                (change)="handleVehicleRegistrationFileInput($event.target.files)"/>
                            <button type="button" id="vehicleRegistrationFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!vehicleRegistrationFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="vehicleRegistrationFile"><small>{{ vehicleRegistrationFile?.name }}</small></div>
                            <div *ngIf="vehicleRegistrationFile && invalidVehicleRegistrationFile" [ngClass]="{ 'is-invalid-file': invalidVehicleRegistrationFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section>
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_NAME_CHANGE_INPUT_UPDATED_INSURANCE_POLICY' | translate }}</section>
                        <section class="col-sm-6" style="text-align: right;">
                            <input type="file"
                                id="insurancePolicyFileInput" name="insurancePolicyFileInput" 
                                style="display: none"
                                accept="application/pdf,image/bmp,image/jpg,image/jpeg,image/png,image/gif" 
                                (change)="handleInsurancePolicyFileInput($event.target.files)"/>
                            <button type="button" id="insurancePolicyFileBtn" class="btn btn-secondary btn-expand">{{ 'COMMON_BTN_SELECT_FILE' | translate }}</button>
                            <div *ngIf="!insurancePolicyFile" [ngClass]="{ 'is-invalid-file': formSubmitted }"><small> {{ 'COMMON_LBL_NO_FILE' | translate }} </small></div>
                            <div *ngIf="insurancePolicyFile"><small>{{ insurancePolicyFile?.name }}</small></div>
                            <div *ngIf="insurancePolicyFile && invalidInsurancePolicyFile" [ngClass]="{ 'is-invalid-file': invalidInsurancePolicyFile }"><small> {{ 'COMMON_LBL_ERROR_FILE' | translate }} </small></div>
                        </section>                                              
                    </div>                   
                    <div *ngIf="formSubmitted && (customForm.invalid || invalidGovernmentIdFile || invalidVehicleRegistrationFile || invalidInsurancePolicyFile)" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
                <p> </p>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>